module.exports = __webpack_public_path__ + "static/img/15.e2d394c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/sp/15.png
// module id = /dh4
// module chunks = 0